<template>
  <div>
    <div class="container h-100">
      <div class="row justify-content-center align-items-center h-100">
        <div class="col-md-8 text-center">
          <h1 class="text-glitch fw-bold" data-glitch="404">404</h1>
          <h4 class="fw-bold mt-5">Oops! Something's missing.</h4>
          <h6 class="fw-500">It seems you're in the wrong page D:</h6>
          <p class="subtitle-1 text-muted mb-4"><span class="text-gradient-animate">Note:</span> We redesign the
            website, so some links might
            not work anymore, but they still exist as new ones. Try clicking the button down below and go to the page
            you are looking for! 😄</p>
          <router-link to="/" class="btn btn-primary btn-round ripple px-5">Back home</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
  metaInfo: {
    title: 'Page Not Found'
  },
}
</script>